import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// GA4 pageview tracker. Reads REACT_APP_GA_MEASUREMENT_ID from env.
// If the env var is missing, the hook is a no-op — nothing loads, no analytics ping.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const useGoogleAnalytics = () => {
  const location = useLocation();
  const injected = useRef(false);

  // One-time script injection
  useEffect(() => {
    if (!GA_ID || injected.current) return;
    injected.current = true;

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line prefer-rest-params
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    // send_page_view=false because we send pageviews manually on route change
    window.gtag("config", GA_ID, { send_page_view: false });
  }, []);

  // Fire pageview on every location change
  useEffect(() => {
    if (!GA_ID || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
};

export default useGoogleAnalytics;
